import { useEffect, useRef } from 'react';

// Safari/Chrome restore pages from the back-forward cache with React state
// FROZEN exactly as it was when the page navigated away — so a component that
// set "Opening secure payment…" right before window.location.assign(paypage)
// comes back from the paypage's Back button with the spinner stuck on forever.
//
// Mount this in any component that hands the browser off to the hosted paypage
// and pass a reset callback that clears every "in-flight payment" flag:
//
//   useBfcacheReset(() => { setPaying(false); setCardSubmitting(false); });
//
// The callback only fires for PERSISTED restores (event.persisted) — normal
// loads/mounts are untouched.
export default function useBfcacheReset(reset) {
    const resetRef = useRef(reset);
    resetRef.current = reset;

    useEffect(() => {
        const onPageShow = (e) => {
            if (e.persisted && resetRef.current) resetRef.current();
        };
        window.addEventListener('pageshow', onPageShow);
        return () => window.removeEventListener('pageshow', onPageShow);
    }, []);
}
